module.exports = __webpack_public_path__ + "static/implementation-payment-process-f1ee671c7c9cae2ea72f9a2b769079a6.png";